import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import { Col, Row, Tabs } from "antd";
import { DndProvider } from "react-dnd";
import { useSearchParams } from "react-router-dom";
import { HTML5Backend } from "react-dnd-html5-backend";

import "../../assets/css/user-management.css";
import CreateUserForm from "./CreateUserForm";
import UserListing from "./UserListing";
import CreateRoleForm from "./roles-management/CreateRoleForm";
import RoleBasedPermissions from "./roles-management/RoleBasedPermissions";
import { getAllRoles } from "../../actionCreator/roleManagementActionCreator";
import RoleHierarchy from "./roles-management/RoleHierarchy";
import CreateTeamForm from "./team-management/CreateTeamForm";
import TeamListing from "./team-management/TeamListing";

const UserManager = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const [activeTab, setActiveTab] = useState();
  const tab = searchParams.get("tab");

  useEffect(() => {
    dispatch(getAllRoles());
  }, [dispatch]);

  useEffect(() => {
    if (tab) {
      setActiveTab(tab);
    } else {
      setActiveTab("1");
    }
  }, [tab]);

  return (
    <section className="font-roboto padd-90 h-100">
      <div className="settings-card user-management">
        <Tabs
          activeKey={activeTab}
          onChange={(val) => {
            const newSearchParams = new URLSearchParams();
            newSearchParams.set("tab", val);

            navigate(`${location.pathname}?${newSearchParams.toString()}`, {
              replace: true,
            });
          }}
          items={[
            {
              key: "1",
              label: "User Management",
              children: (
                <>
                  {(typeof activeTab === "string"
                    ? parseInt(activeTab)
                    : activeTab) === 1 && (
                    <Row gutter={24}>
                      <Col xs={24} lg={10}>
                        <CreateUserForm />
                      </Col>
                      <Col xs={24} lg={14}>
                        <UserListing />
                      </Col>
                    </Row>
                  )}
                </>
              ),
            },
            {
              key: "2",
              label: "Team Management",
              children: (
                <>
                  {(typeof activeTab === "string"
                    ? parseInt(activeTab)
                    : activeTab) === 2 && (
                    <Row gutter={24}>
                      <Col xs={24} lg={10}>
                        <CreateTeamForm />
                      </Col>
                      <Col xs={24} lg={14}>
                        <TeamListing />
                      </Col>
                    </Row>
                  )}
                </>
              ),
            },
            {
              key: "3",
              label: "Permission Management",
              children: (
                <>
                  {(typeof activeTab === "string"
                    ? parseInt(activeTab)
                    : activeTab) === 3 && (
                    <Tabs
                      defaultActiveKey="1"
                      className="equal-width-tabs"
                      items={[
                        {
                          key: "1",
                          label: "Permission Matrix",
                          children: (
                            <Row gutter={24}>
                              <Col xs={24} lg={8}>
                                <CreateRoleForm />
                              </Col>
                              <Col xs={24} lg={16}>
                                <DndProvider backend={HTML5Backend}>
                                  <RoleBasedPermissions />
                                </DndProvider>
                              </Col>
                            </Row>
                          ),
                        },
                        {
                          key: "2",
                          label: "Role Hierarchy",
                          children: (
                            <DndProvider backend={HTML5Backend}>
                              <RoleHierarchy />
                            </DndProvider>
                          ),
                        },
                      ]}
                    />
                  )}
                </>
              ),
            },
          ]}
        />
      </div>
    </section>
  );
};

export default UserManager;
